"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getPercentage(value, total, decimals) {
    if (total === 0) {
        return "0%";
    }
    else {
        var percentage = (value / total) * 100;
        var remainder = percentage % 1;
        if (percentage.toFixed(1) === "100.0") {
            return "100%";
        }
        if (remainder === 0) {
            return percentage + "%";
        }
        else {
            var decimalPoints = remainder.toString().split(".")[1];
            if (decimalPoints.length > 1) {
                if (decimalPoints[0] === "0") {
                    var truncated = percentage | 0;
                    return truncated === 0 ? "0.1%" : truncated + "%";
                }
            }
            var oneDecimalPlace = percentage.toFixed(decimals ? decimals : 1);
            return oneDecimalPlace === "0.0" ? "0.1%" : oneDecimalPlace + "%";
        }
    }
}
exports.getPercentage = getPercentage;
